import Swiper from 'swiper';

class MobileAccordion {
  private titles: HTMLElement[] = [];
  private activeContainer: HTMLElement | null = null;
  private initialized: boolean = false;

  constructor() {
    if (window.matchMedia('(max-width: 639px)').matches) {
      this.init();
    }

    window.matchMedia('(max-width: 639px)').addEventListener('change', (e) => {
      if (e.matches) {
        this.init();
      } else {
        this.resetAccordions();
      }
    });
  }

  private init() {
    if (this.initialized) return;
    const getSwiperInstance = (container: HTMLElement): Swiper | null => {
      const swiperEl = container.querySelector(
        '.slider-medias__swiper'
      ) as HTMLElement;
      return swiperEl && (swiperEl as any).swiper
        ? (swiperEl as any).swiper
        : null;
    };

    this.titles = Array.from(
      document.querySelectorAll('.title-mobile')
    ) as HTMLElement[];

    this.titles.forEach((title) => {
      const container = title.nextElementSibling as HTMLElement;
      if (!container || !container.classList.contains('container-mobile'))
        return;

      // Initial state
      container.style.maxHeight = '0px';
      container.style.overflow = 'hidden';
      container.style.transition = 'max-height 0.3s ease';

      // Setup title styles/accessibility
      title.style.userSelect = 'none';
      title.style.touchAction = 'manipulation';
      title.style.cursor = 'pointer';
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');

      title.addEventListener('click', async (e) => {
        e.preventDefault();

        const isOpen = container.style.maxHeight !== '0px';

        if (this.activeContainer && this.activeContainer !== container) {
          this.activeContainer.style.maxHeight = '0px';
        }

        if (isOpen) {
          container.style.maxHeight = '0px';
          this.activeContainer = null;
        } else {
          const waitForContentReady = (
            el: HTMLElement,
            tries = 10
          ): Promise<void> => {
            return new Promise((resolve) => {
              const check = () => {
                const initialHeight = el.scrollHeight;
                requestAnimationFrame(() => {
                  if (el.scrollHeight !== initialHeight && tries > 0) {
                    setTimeout(() => check(), 100); // Attend une frame + delay
                  } else {
                    resolve();
                  }
                });
              };
              check();
            });
          };

          const swiper = getSwiperInstance(container);
          if (swiper) {
            swiper.update();
          }

          await waitForContentReady(container); // Attend que swiper et contenus dynamiques soient rendus

          if (swiper) swiper.update(); // encore une fois après attente

          // Forcer un reflow et attendre encore un peu
          requestAnimationFrame(() => {
            setTimeout(() => {
              container.style.maxHeight = container.scrollHeight + 'px';
              this.activeContainer = container;

              setTimeout(() => {
                title.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 100);
            }, 100); // petit délai de sécurité
          });

          setTimeout(() => {
            title.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      });
    });

    this.initialized = true;
  }

  private resetAccordions() {
    this.titles.forEach((title) => {
      const container = title.nextElementSibling as HTMLElement;
      if (container && container.classList.contains('container-mobile')) {
        container.style.maxHeight = '';
        container.style.overflow = '';
        container.style.transition = '';
      }
    });
    this.activeContainer = null;
    this.initialized = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MobileAccordion();
});
